import React from "react";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";

export default function MockTestSummary() {
  const { MockStore } = useStores();
  const renderSuggestionWithBold = () => {
    const summary = MockStore.report?.summary || "";
    return summary.split("\n").map((line, index) => {
      const trimmedLine = line.trim();

      if (/^---$/.test(trimmedLine)) {
        return <hr key={index} className="my-4 border-gray-300" />;
      }

      if (/^#+\s/.test(trimmedLine)) {
        const level = trimmedLine.match(/^#+/)[0].length;
        const content = trimmedLine.replace(/^#+\s+/, "");
        const className =
          level === 1
            ? "text-2xl font-bold mt-8 mb-4 text-gray-900"
            : level === 2
              ? "text-xl font-bold mt-6 mb-3 text-gray-800"
              : "text-lg font-semibold mt-4 mb-2 text-gray-700";
        return (
          <div key={index} className={className}>
            {renderInlineMarkdown(content)}
          </div>
        );
      }

      if (
        /^\d+\./.test(trimmedLine) ||
        /^[\-\*\+]\s/.test(trimmedLine) ||
        trimmedLine.startsWith("-") ||
        trimmedLine.startsWith("*")
      ) {
        const leadingSpaces = line.match(/^\s*/)[0].length;
        const indentationLevel = Math.floor(leadingSpaces / 2);
        const content = trimmedLine
          .replace(/^\d+\.\s+/, "")
          .replace(/^[\-\*\+]\s+/, "")
          .replace(/^[\-\*]/, "");
        const isOrdered = /^\d+\./.test(trimmedLine);
        return (
          <div
            key={index}
            className={`flex gap-2 my-1 ${isOrdered ? "" : "ml-4"}`}
            style={{
              marginLeft: `${indentationLevel * 1.5 + (isOrdered ? 0 : 1)}rem`,
            }}
          >
            {isOrdered ? (
              <span className="font-bold whitespace-nowrap">
                {trimmedLine.match(/^\d+\./)[0]}
              </span>
            ) : (
              <span className="text-gray-400">•</span>
            )}
            <div className="flex-1 text-gray-700">
              {renderInlineMarkdown(content)}
            </div>
          </div>
        );
      }

      if (trimmedLine === "") return <div key={index} className="h-2" />;

      return (
        <div key={index} className="my-1 text-gray-700">
          {renderInlineMarkdown(line)}
        </div>
      );
    });
  };

  const renderInlineMarkdown = (text) => {
    let parts = text.split("**");
    if (parts.length > 1) {
      return parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="font-bold text-gray-900">
            {part}
          </strong>
        ) : (
          renderInlineMarkdown(part)
        ),
      );
    }

    parts = text.split("*");
    if (parts.length > 1) {
      return parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="font-semibold text-gray-800">
            {part}
          </strong>
        ) : (
          part
        ),
      );
    }

    return text;
  };

  return useObserver(() => (
    <div className="mt-8 mb-10 max-w-4xl">
      <h1 className="text-3xl font-bold text-[#FF6B00] mb-6">Summary</h1>
      <div className="space-y-1">{renderSuggestionWithBold()}</div>
    </div>
  ));
}
